/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Price_CapInputs */

const en_admin_resource_form_price_cap = /** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price cap`)
};

const de_admin_resource_form_price_cap = /** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisdeckelung`)
};

const es_admin_resource_form_price_cap = /** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio máximo`)
};

const fr_admin_resource_form_price_cap = /** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plafonnement de prix`)
};

/** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */
const it_admin_resource_form_price_cap = en_admin_resource_form_price_cap;

/** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */
const pt_br2_admin_resource_form_price_cap = en_admin_resource_form_price_cap;

/** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */
const pl_admin_resource_form_price_cap = en_admin_resource_form_price_cap;

/** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */
const hu_admin_resource_form_price_cap = en_admin_resource_form_price_cap;

/** @type {(inputs: Admin_Resource_Form_Price_CapInputs) => LocalizedString} */
const ro_admin_resource_form_price_cap = en_admin_resource_form_price_cap;

/**
* | output |
* | --- |
* | "Price cap" |
*
* @param {Admin_Resource_Form_Price_CapInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_price_cap = /** @type {((inputs?: Admin_Resource_Form_Price_CapInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Price_CapInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_price_cap(inputs)
	if (locale === "de") return de_admin_resource_form_price_cap(inputs)
	if (locale === "es") return es_admin_resource_form_price_cap(inputs)
	if (locale === "fr") return fr_admin_resource_form_price_cap(inputs)
	if (locale === "it") return it_admin_resource_form_price_cap(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_price_cap(inputs)
	if (locale === "pl") return pl_admin_resource_form_price_cap(inputs)
	if (locale === "hu") return hu_admin_resource_form_price_cap(inputs)
	return ro_admin_resource_form_price_cap(inputs)
});
export { admin_resource_form_price_cap as "admin.resource_form.price_cap" }